import { useState } from 'react'
import { auth } from '@/api/endpoints'
import { Button } from '@/components/ui/button'
import { DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Err } from '@/components/Err'

// 비밀번호 바꾸기(F-14, F-37 에서 내 정보로 옮김, F-47 에서 대화 상자로).
// 현재 비밀번호가 맞아야 하고 새 비밀번호는 8자 이상이며 두 번 같아야 한다.

export function PasswordForm({ onClose }: { onClose: () => void }) {
  const [current, setCurrent] = useState('')
  const [next, setNext] = useState('')
  const [again, setAgain] = useState('')
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<unknown>(null)
  const same = next.length > 0 && next === again
  const submit = async (e: React.FormEvent) => {
    e.preventDefault()
    setBusy(true)
    setError(null)
    try {
      await auth.changePassword(current, next)
      onClose()
    } catch (err) {
      setError(err)
      setBusy(false)
    }
  }
  return (
    <form onSubmit={submit} className="grid gap-3">
      <DialogHeader>
        <DialogTitle>비밀번호 바꾸기</DialogTitle>
      </DialogHeader>
      <div className="grid gap-1.5">
        <Label htmlFor="pw-current">현재 비밀번호</Label>
        <Input id="pw-current" type="password" autoComplete="current-password" value={current} disabled={busy} onChange={(e) => setCurrent(e.target.value)} />
      </div>
      <div className="grid gap-1.5">
        <Label htmlFor="pw-next">새 비밀번호</Label>
        <Input id="pw-next" type="password" autoComplete="new-password" minLength={8} value={next} disabled={busy} onChange={(e) => setNext(e.target.value)} />
      </div>
      <div className="grid gap-1.5">
        <Label htmlFor="pw-again">새 비밀번호 확인</Label>
        <Input id="pw-again" type="password" autoComplete="new-password" value={again} disabled={busy} onChange={(e) => setAgain(e.target.value)} />
      </div>
      {again.length > 0 && !same ? <p className="text-[12px] text-danger-ink">새 비밀번호가 서로 다릅니다.</p> : null}
      <Err error={error} />
      <DialogFooter>
        <Button type="button" variant="outline" disabled={busy} onClick={onClose}>
          취소
        </Button>
        <Button type="submit" disabled={busy || !current || next.length < 8 || !same}>
          {busy ? '변경 중' : '변경'}
        </Button>
      </DialogFooter>
    </form>
  )
}
